// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"e62e1b1a","369":"dc70187e","447":"dc70187e"}[chunkId] + ".chunk.css";
};